import { motion } from 'framer-motion';
import ButtonLink from '@components/common/Button/ButtonLink';
import { usePageSetup } from '@/hooks/usePageSetup';

export const TermsOfServicePage = () => {
  usePageSetup('Naudojimosi taisyklės - Finhudas', { scroll: true })

  return (
    <div className="h-full bg-white p-5 pt-8 pb-8 flex flex-col">
      <div className="flex-1 overflow-y-auto">
        <motion.h1
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
          className="text-2xl font-bold mb-4 text-center"
        >
          NAUDOJIMOSI TAISYKLĖS
        </motion.h1>
        <div className="space-y-4 text-base text-gray-800">
          <h2 className="text-lg font-semibold mt-6">1. BENDROSIOS NUOSTATOS</h2>
          <p>1.1. Šios naudojimosi taisyklės (toliau – Taisyklės) nustato MB Kurohudas (juridinio asmens kodas: 306705828, adresas: Vytauto g. 34-5, LT-92127 Klaipėda, Lietuva) (toliau – Paslaugų teikėjas) mobiliosios programėlės ir interneto svetainės „Finhudas" (toliau – Paslauga) naudojimo sąlygas.</p>
          <p>1.2. Naudodamiesi Paslauga, Jūs (toliau – Vartotojas) sutinkate su šiomis Taisyklėmis ir įsipareigojate jų laikytis. Jei nesutinkate su Taisyklėmis, prašome nesinaudoti Paslauga.</p>
          <p>1.3. Paslaugų teikėjas turi teisę vienašališkai keisti Taisykles. Naujausia Taisyklių versija visada bus pateikiama Paslaugos svetainėje ar programėlėje.</p>

          <h2 className="text-lg font-semibold mt-6">2. PASLAUGOS APRAŠYMAS</h2>
          <p>2.1. „Finhudas" yra skaitmeninė platforma, kuri padeda individualią veiklą vykdantiems pavežėjams, sekti savo faktines veiklos išlaidas.</p>
          <p>2.2. Paslauga nėra mokesčių konsultavimo ar apskaitos paslauga. Naudojimosi Paslauga metu pateikta informacija yra tik rekomendacinio pobūdžio.</p>

          <h2 className="text-lg font-semibold mt-6">3. VARTOTOJO TEISĖS IR PAREIGOS</h2>
          <p>3.1. Vartotojas turi teisę:</p>
          <ul className="list-disc ml-6">
            <li>a) Naudotis Paslauga pagal šiose Taisyklėse nustatytas sąlygas;</li>
            <li>b) Gauti informaciją apie savo asmens duomenų tvarkymą (plačiau Žr. Privatumo politiką);</li>
            <li>c) Kreiptis į Paslaugų teikėją kilus klausimams dėl Paslaugos naudojimo.</li>
          </ul>
          <p>3.2. Vartotojas įsipareigoja:</p>
          <ul className="list-disc ml-6">
            <li>a) Suteikti tikslią ir teisingą informaciją registruojantis ir naudojantis Paslauga;</li>
            <li>b) Nenaudoti Paslaugos neteisėtiems ar Taisykles pažeidžiantiems veiksmams vykdyti;</li>
            <li>c) Naudotis Paslauga pagal paskirtį vadovaujantis sąžiningo ir nekenkėjiško naudojimosi principais.</li>
          </ul>

          <h2 className="text-lg font-semibold mt-6">4. PASLAUGŲ TEIKĖJO TEISĖS IR PAREIGOS</h2>
          <p>4.1. Paslaugų teikėjas turi teisę:</p>
          <ul className="list-disc ml-6">
            <li>a) Keisti, atnaujinti ar nutraukti Paslaugos teikimą apie tai pranešęs Vartotojams;</li>
            <li>b) Sustabdyti ar nutraukti Vartotojo prieigą prie Paslaugos, jei Vartotojas pažeidžia Taisykles ar įstatymus.</li>
          </ul>
          <p>4.2. Paslaugų teikėjas įsipareigoja:</p>
          <ul className="list-disc ml-6">
            <li>a) Teikti Paslaugą laikantis Taisyklių ir teisės aktų reikalavimų;</li>
            <li>b) Saugoti Vartotojo asmens duomenis pagal galiojančius duomenų apsaugos teisės aktus;</li>
          </ul>

          <h2 className="text-lg font-semibold mt-6">5. ATSAKOMYBĖS APRIBOJIMAS</h2>
          <p>5.1. Paslaugų teikėjas neatsako už:</p>
          <ul className="list-disc ml-6">
            <li>a) Bet kokius nuostolius, kuriuos Vartotojas patyrė naudodamasis Paslauga, jei nuostoliai atsirado dėl neteisingo ar netikslaus Paslaugos naudojimo;</li>
            <li>b) Trečiųjų šalių veiksmus ar neveikimą, susijusią su Paslaugos prieinamumu ar veikimu;</li>
            <li>c) Vartotojo ar trečiųjų šalių patirtus nuostolius dėl Paslaugos veikimo sutrikimų, nebent tokie sutrikimai atsirado dėl tyčinių Paslaugų teikėjo veiksmų.</li>
          </ul>

          <h2 className="text-lg font-semibold mt-6">6. INTELEKTINĖ NUOSAVYBĖ</h2>
          <p>6.1. Visi su Paslauga susiję intelektinės nuosavybės teisės objektai (prekiniai ženklai, logotipai, tekstai, programinė įranga ir kt.) priklauso Paslaugų teikėjui arba yra teisėtai naudojami pagal licencijas.</p>
          <p>6.2. Draudžiama kopijuoti, platinti, modifikuoti ar kitaip naudoti Paslaugos turinį be raštiško Paslaugų teikėjo sutikimo.</p>

          <h2 className="text-lg font-semibold mt-6">7. GINČŲ SPRENDIMAS</h2>
          <p>7.1. Visi ginčai tarp Paslaugų teikėjo ir Vartotojo sprendžiami derybų būdu. Nepavykus susitarti, ginčai sprendžiami Lietuvos Respublikos teismuose pagal Paslaugų teikėjo buveinės vietą.</p>

          <h2 className="text-lg font-semibold mt-6">8. BAIGIAMOSIOS NUOSTATOS</h2>
          <p>8.1. Šios Taisyklės sudarytos ir aiškinamos pagal Lietuvos Respublikos teisę.</p>
          <p>8.2. Jei kuri nors Taisyklių nuostata tampa negaliojanti ar neįvykdoma, likusios nuostatos lieka galioti.</p>
          <p>8.3. Jei turite klausimų apie šias Taisykles, galite susisiekti su Paslaugų teikėju el. paštu: <a href="mailto:info@finhudas.lt" className="text-blue-600 underline">info@finhudas.lt</a>.</p>

          <div className="text-xs text-gray-500 mt-8">
            © 2025 MB Kurohudas. Visos teisės saugomos. Paskutinės redakcijos data: 2025.01.21
          </div>
        </div>
      </div>
      <div className="mt-8">
        <ButtonLink to="/profile">
          Grįžti atgal
        </ButtonLink>
      </div>
    </div>
  );
}

export default TermsOfServicePage;
